module.exports = __webpack_public_path__ + "static/media/tankTrailer_tomato.4270039f.svg";